import queryString from "query-string";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import useProfessional from "src/Professional/hooks/useProfessional";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import { decryptString } from "src/shared/global/cryptoJSUtilities";

const MedicoAgendaDirecta = () => {
  const query = queryString.parse(window.location.search, { decode: false });
  const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
  const {
    loadDaysAvailableAndDefault,
    loadDaysAvailableProcedimientoAndDefault,
    loadDaysAvailableImagenologiaAndDefault,
  } = useSearchHours();
  const { loadDetailProfessional } = useProfessional();

  useEffect(() => {
    (async function () {
      if (query.qrp && query.qrp !== "") {
        const decode = decryptString(query.qrp);
        console.log(decode, "externo");

        const arr = decode.split("_");
        const [
          ptdRut,
          exaCorrel,
          sueCorrel,
          aseCorrel,
          tipo,
          serNombre,
          tipoNombre,
        ] = arr;

        console.log(
          ptdRut,
          exaCorrel,
          sueCorrel,
          aseCorrel,
          tipo,
          serNombre,
          tipoNombre,
          "variables externo",
        );

        if (arr.length === 1) {
          const professional = await loadDetailProfessional(ptdRut);

          if (professional && professional.length > 0) {
            setFilterSearchSelected((current) => ({
              ...current,
              specialitySelected: {
                code: null,
                value: null,
              },
              professionalSelected: {
                ...current.professionalSelected,
                code: professional[0].ptdRut,
                value: professional[0].ptdNombre,
              },
            }));

            setTimeout(() => {
              loadDaysAvailableAndDefault();
            }, 0);
          }
        } else if (tipo === "PCD") {
          setFilterSearchSelected((current) => ({
            ...current,
            servicioSelected: {
              ...current.servicioSelected,
              code: aseCorrel,
              value: tipoNombre,
            },
            procedimientoSelected: {
              ...current.servicioSelected,
              code: exaCorrel,
              value: serNombre,
            },
            sucursalSelected: {
              ...current.sucursalSelected,
              sue_correl: parseInt(sueCorrel),
              code: process.env.REACT_APP_SERVICIO_PCD,
            },
          }));

          setTimeout(() => {
            loadDaysAvailableProcedimientoAndDefault();
          }, 0);
        } else if (tipo === "IMG") {
          setFilterSearchSelected((current) => ({
            ...current,
            examenSelected: {
              ...current.examenSelected,
              code: exaCorrel,
              value: serNombre,
            },
            tipoExamenSelected: {
              ...current.tipoExamenSelected,
              code: ptdRut,
              value: tipoNombre,
            },
            sucursalSelected: {
              ...current.sucursalSelected,
              sue_correl: parseInt(sueCorrel),
              code: process.env.REACT_APP_SERVICIO_IMG,
            },
          }));

          setTimeout(() => {
            loadDaysAvailableImagenologiaAndDefault();
          }, 0);
        }
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default MedicoAgendaDirecta;
